/**
 * Masks the digits of a phone number except for the last two.
 * @param phone Phone number of 10 characters.
 * @returns
 */
export const hidePhone = (phone: string): string => {
  const maskedNumber = `(•••) •••-••${phone.substring(8, 10)}`;
  return maskedNumber;
};
